/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.countries.internal

import features.countries.models.Countries
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class CountriesServiceImpl : CountriesService {

    private val countriesRequest = CountriesRequest()

    override suspend fun getCountries(
        overrideHeaders : Map<String, String>?,
    ): Result<Countries> {
        return countriesRequest.getCountries(
            overrideHeaders = overrideHeaders,
        ).toModel()
    }
}
